import React from "react";
import { Helmet } from "react-helmet";

const UttarPradeshSEO = () => {
  return (
    <Helmet>
      {/* 🟢 BASIC META */}
      <title>
        Buy Sex Toys in Uttar Pradesh | Discreet Delivery in Lucknow, Noida
      </title>

      <meta
        name="description"
        content="Buy sex toys online in Uttar Pradesh with 100% discreet delivery. Trusted adult store delivering to Lucknow, Noida, Ghaziabad, Kanpur, Varanasi & more. Products for men, women & couples."
      />

      <meta
        name="keywords"
        content="sex toys in Uttar Pradesh, buy sex toys Lucknow, sex toys Noida, adult toys Uttar Pradesh, couples sex toys UP, adult store Uttar Pradesh"
      />

      <meta name="robots" content="index, follow" />

      {/* 🟢 CANONICAL */}
      <link
        rel="canonical"
        href="https://lushdesire.in/sex-toys-delivery/uttar-pradesh"
      />

      {/* 🟢 OPEN GRAPH */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Buy Sex Toys in Uttar Pradesh | 100% Discreet Delivery"
      />
      <meta
        property="og:description"
        content="Order premium sex toys in Uttar Pradesh with fast & private delivery. Serving Lucknow, Noida, Ghaziabad, Kanpur & more."
      />
      <meta
        property="og:url"
        content="https://lushdesire.in/sex-toys-delivery/uttar-pradesh"
      />
      <meta
        property="og:image"
        content="https://lushdesire.in/assets/og-uttar-pradesh.jpg"
      />

      {/* 🟢 TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Sex Toys Delivery in Uttar Pradesh | LushDesire"
      />
      <meta
        name="twitter:description"
        content="Discreet sex toys delivery across Uttar Pradesh. Buy toys for men, women & couples online."
      />

      {/* 🟢 LOCAL SEO */}
      <meta name="geo.region" content="IN-UP" />
      <meta name="geo.placename" content="Uttar Pradesh" />
      <meta name="geo.position" content="26.8467;80.9462" />
      <meta name="ICBM" content="26.8467, 80.9462" />

      {/* 🟢 SCHEMA */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Store",
          "name": "LushDesire Uttar Pradesh",
          "url": "https://lushdesire.in/sex-toys-delivery/uttar-pradesh",
          "logo": "https://lushdesire.in/logo.png",
          "description": "Buy sex toys online in Uttar Pradesh with discreet packaging. Trusted adult store delivering across UP.",
          "areaServed": {
            "@type": "State",
            "name": "Uttar Pradesh"
          },
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "Uttar Pradesh",
            "addressCountry": "IN"
          },
          "sameAs": [
            "https://www.facebook.com/lushdesire",
            "https://www.instagram.com/lushdesire"
          ]
        }
        `}
      </script>
    </Helmet>
  );
};

export default UttarPradeshSEO;
